var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_40324",
    "data-name": "Group 40324",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14932",
    "data-name": "Rectangle 14932",
    width: 16,
    height: 16,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "phone_1_",
    "data-name": "phone (1)",
    d: "M16.951,13.41a1.144,1.144,0,0,0-.582-.724l-2.985-1.547a1.137,1.137,0,0,0-1.448.331l-.483.661a.174.174,0,0,1-.224.051A8.761,8.761,0,0,1,9.3,10.692,8.763,8.763,0,0,1,7.809,8.762a.174.174,0,0,1,.051-.224l.659-.483a1.137,1.137,0,0,0,.331-1.448L7.312,3.623A1.142,1.142,0,0,0,5.666,3.2L3.79,4.454a1.805,1.805,0,0,0-.8,1.615A9.084,9.084,0,0,0,3.2,7.654a12.951,12.951,0,0,0,3.444,5.693,12.853,12.853,0,0,0,5.693,3.437A9.091,9.091,0,0,0,13.927,17h.121a1.805,1.805,0,0,0,1.492-.794l1.25-1.875A1.142,1.142,0,0,0,16.951,13.41Zm-.965.381-1.243,1.878a.845.845,0,0,1-.753.369,8.343,8.343,0,0,1-1.407-.186,11.907,11.907,0,0,1-5.249-3.193A12.008,12.008,0,0,1,4.143,7.41,8.336,8.336,0,0,1,3.954,6a.837.837,0,0,1,.369-.751L6.2,4a.171.171,0,0,1,.1-.029h.046a.174.174,0,0,1,.111.089L8,7.048a.176.176,0,0,1-.051.222l-.659.483a1.139,1.139,0,0,0-.309,1.479A9.784,9.784,0,0,0,8.62,11.359,9.779,9.779,0,0,0,10.746,13a1.139,1.139,0,0,0,1.479-.309l.483-.661a.176.176,0,0,1,.222-.051l2.985,1.545a.176.176,0,0,1,.065.253Z",
    transform: "translate(-1.986 -2.007)",
    fill: "#b2b9c4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneOutline);
export default __webpack_public_path__ + "static/media/phone-outline.5c5f6da92ee46fb69d925815feb41eb5.svg";
export { ForwardRef as ReactComponent };